import type { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    link: {
      cursor: 'pointer',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.primary.dark
      }
    },
    termsTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold'
    },
    policy: {
      whiteSpace: 'pre-wrap'
    }
  });

export default styles;
